import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tooltip from 'components/Tooltip';

import { expandDataProps } from 'utils/helper/common';

import './input-checkbox.scss';

const InputCheckbox = (props) => {
  const {
    containerClass,
    labelClass,
    refCallback,
    id,
    label,
    size,
    type,
    data,
    tooltipMessage,
    tooltipClassNameWrapper,
    tooltipClassName,
    ...inputProps
  } = props;

  const containerClasses = classNames({
    'input-checkbox': true,
    [containerClass]: true
  });

  const labelClasses = classNames({
    'input-checkbox__label': true,
    'input-checkbox__label--disabled': inputProps.disabled,
    [`input-checkbox__label--size-${size}`]: size,
    [`input-checkbox__label--type-${type}`]: type,
    [labelClass]: Boolean(labelClass)
  });

  const dataProps = {
    qa: `input-checkbox-${id}`,
    ...data
  };

  const tooltipWrapperClasses = classNames(tooltipClassNameWrapper);
  const tooltipClasses = classNames(tooltipClassName);

  return (
    <section className={containerClasses}>
      <input
        id={`checkbox-${id}`}
        type="checkbox"
        className="input-checkbox__input"
        ref={refCallback}
        {...inputProps}
        {...expandDataProps(dataProps)}
      />
      <label // eslint-disable-line jsx-a11y/label-has-for
        className={labelClasses}
        htmlFor={`checkbox-${id}`}
      >
        <span className="input-checkbox__text">{label}</span>
        {
          tooltipMessage &&
            <span className="input-checkbox__tooltip-mark input-checkbox__tooltip-mark--after">
              <Tooltip
                message={tooltipMessage}
                classNameWrapper={tooltipWrapperClasses}
                className={tooltipClasses}
                showQuestionMark
              />
            </span>
        }
      </label>
    </section>
  );
};

InputCheckbox.propTypes = {
  containerClass: PropTypes.string,
  labelClass: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  checked: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  tooltipClassNameWrapper: PropTypes.string,
  tooltipClassName: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'medium-small', 'small']),
  type: PropTypes.oneOf(['filter', 'regular', 'text']),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  refCallback: PropTypes.func,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  onBlur: PropTypes.func,
  data: PropTypes.any
};

InputCheckbox.defaultProps = {
  label: '',
  labelClass: '',
  containerClass: '',
  size: 'medium',
  type: 'regular',
  onChange: () => {},
  onKeyPress: () => {},
  onBlur: () => {}
};

export default InputCheckbox;
